import Conditional from 'decorators/conditional';
import Mobile from './index.mobile';
import Desktop from './index.desktop';

export default Conditional({
  default: Desktop,
  desktop: Desktop,
  mobile: Mobile,
});
